import type { SearchDataModel } from "~/types/models/SearchData.model";
import axios from "axios";

export const useApiService = () => {
  function handleError(err: unknown, message?: string): unknown {
    if (axios.isAxiosError(err) && err.response?.status) {
      const finalMessage = message ? `${message}. ${err.message}` : err.message;
      // console.error(`[${err.config?.method}] ${err.config?.url}`, err.message);
      return Error(finalMessage);
    } else if (err instanceof Error) {
      const finalMessage = message ? `${message}. ${err.message}` : err.message;
      // console.error(err.message);
      return Error(finalMessage);
    } else {
      return err;
    }
  }

  const getFetchData = async <T>(
    endpoint: string,
    dataKey: string,
    catchError: boolean = true,
    retry: number = 0
  ): Promise<T> => {
    try {
      return (await axios.get(endpoint)).data;
    } catch (err) {
      throw handleError(err);
    }
  };

  const postFetchData = async <T>(
    endpoint: string,
    params: SearchDataModel
  ): Promise<T> => {
    try {
      return (await axios.post(endpoint, params)).data;
    } catch (err) {
      throw handleError(err);
    }
  };

  return { getFetchData, postFetchData };
};
